module.exports = __webpack_public_path__ + "img/msg.ecf7acab.png";